<template>
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    :viewBox="`0 0 464 464`" style="enable-background:new 0 0 464 464;" xml:space="preserve">
    <g :style="`transform-origin: center; 
                transform: scale(${weight}, ${height});`">
        <g>
            <g @click="$emit('change', {event: $event, item: 'body'})">
                <path :style="body_color" d="M348.745,266.644l-39.324-65.54c-3.479-5.798-9.242-9.86-15.873-11.186L263.958,184h-32h-32
                    l-29.589,5.918c-6.631,1.326-12.394,5.388-15.873,11.186l-39.324,65.54c-1.889,3.148-1.393,7.177,1.203,9.773l12.683,12.683
                    c3.57,3.57,9.513,2.981,12.313-1.219L167.958,248l-3.867,42.532c-2.736,30.098-0.39,60.441,6.94,89.761l17.524,70.096
                    c2,8,9.187,13.611,17.433,13.611l0,0c9.924,0,17.97-8.045,17.97-17.97V376c0-4.418,3.582-8,8-8l0,0c4.418,0,8,3.582,8,8v70.03
                    c0,9.924,8.045,17.97,17.97,17.97l0,0c8.246,0,15.433-5.612,17.433-13.611l17.524-70.096c7.33-29.319,9.676-59.663,6.94-89.761
                    L295.958,248l26.587,39.88c2.8,4.201,8.744,4.789,12.313,1.219l12.683-12.683C350.137,273.821,350.633,269.792,348.745,266.644z"
                    />
            </g>
        </g>
        <path :style="skin_color" d="M271.343,185.477L263.958,184h-64l-7.385,1.477l-3.23,0.64
            c5.097,18.662,22.161,32.384,42.439,32.384c20.299,0,37.377-13.75,42.455-32.44L271.343,185.477z"/>
        <g>
            <g @click="$emit('change', {event: $event, item: 'skin'})">
                <circle :style="skin_color" cx="123.292" cy="288" r="16"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'skin'})">
                <circle :style="skin_color" cx="340.708" cy="288" r="16"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'arm'})">
                <path :style="arm_color" d="M159.68,195.204c-2,1.687-3.81,3.61-5.184,5.899l-39.324,65.54
                    c-1.889,3.147-1.393,7.177,1.203,9.772l12.683,12.684c3.57,3.57,9.513,2.981,12.313-1.219L167.958,248
                    C167.958,248,176.833,224.32,159.68,195.204z"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'wrist'})">
                <path :style="wrist_color" d="M117.958,262l-2.786,4.644c-1.889,3.147-1.393,7.177,1.203,9.772l12.683,12.684
                    c3.57,3.57,9.513,2.981,12.313-1.219l0.987-1.48L117.958,262z"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'arm'})">
                <path :style="arm_color" d="M304.237,195.204c2,1.687,3.81,3.61,5.184,5.899l39.324,65.54
                    c1.889,3.147,1.393,7.177-1.203,9.772L334.859,289.1c-3.57,3.57-9.513,2.981-12.313-1.219L295.958,248
                    C295.958,248,287.083,224.32,304.237,195.204z"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'wrist'})">
                <path :style="wrist_color" d="M345.958,262l2.786,4.644c1.889,3.147,1.393,7.177-1.203,9.772L334.859,289.1
                    c-3.57,3.57-9.513,2.981-12.313-1.219l-0.987-1.48L345.958,262z"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'wrist'})">
                <path :style="wrist_color" d="M176.796,188.633c4.45,24.568,27.46,43.367,55.162,43.367s50.712-18.798,55.163-43.367
                    l-15.778-3.156C268.385,202.719,251.93,216,231.958,216s-36.426-13.281-39.385-30.523L176.796,188.633z"/>
            </g>
        </g>
        <g>
            <g>
                <g @click="$emit('change', {event: $event, item: 'wrist'})">
                    <path :style="wrist_color" d="M205.989,464c9.924,0,17.97-8.045,17.97-17.97V440h-38l2.597,10.389
                        C190.555,458.389,197.743,464,205.989,464z"/>
                </g>
            </g>
            <g>
                <g @click="$emit('change', {event: $event, item: 'wrist'})">
                    <path :style="wrist_color" d="M239.958,440v6.03c0,9.925,8.045,17.97,17.97,17.97c8.246,0,15.433-5.611,17.433-13.611
                        L277.958,440H239.958z"/>
                </g>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'circle1'})">
                <circle :style="circle_1_color" cx="231.958" cy="328" r="8"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'circle1'})">
                <circle :style="circle_1_color" cx="215.958" cy="304" r="8"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'circle2'})">
                <circle :style="circle_2_color" cx="263.958" cy="328" r="8"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'circle2'})">
                <circle :style="circle_2_color" cx="247.958" cy="304" r="8"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'circle1'})">
                <circle :style="circle_1_color" cx="279.958" cy="304" r="8"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'circle2'})">
                <circle :style="circle_2_color" cx="199.958" cy="328" r="8"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'circle2'})">
                <circle :style="circle_2_color" cx="183.958" cy="304" r="8"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'circle1'})">
                <path :style="circle_1_color" d="M295.958,320c-4.418,0-8,3.582-8,8s3.582,8,8,8c1.59,0,2.987-0.582,4.232-1.383
                    c0.313-4.268,0.502-8.544,0.611-12.822C299.444,320.734,297.814,320,295.958,320z"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'circle1'})">
                <path :style="circle_1_color" d="M167.958,320c-1.856,0-3.486,0.734-4.843,1.795c0.109,4.278,0.298,8.555,0.611,12.822
                    c1.246,0.801,2.642,1.383,4.232,1.383c4.418,0,8-3.582,8-8S172.377,320,167.958,320z"/>
            </g>
        </g>
    </g>
    <g :style="`transform: translateY(${10 * height}px)`">
        <g>
            <g @click="$emit('change', {event: $event, item: 'skin'})">
                <path :style="skin_color + 'EE'" d="M327.958,72c-1.051,0-2.052,0.178-3.067,0.309C314.327,30.77,276.786,0,231.958,0
                    s-82.369,30.77-92.933,72.309C138.01,72.178,137.009,72,135.958,72c-13.255,0-24,10.745-24,24s10.745,24,24,24
                    c1.051,0,2.052-0.178,3.067-0.309C149.59,161.23,187.131,192,231.958,192s82.369-30.77,92.933-72.309
                    c1.015,0.131,2.016,0.309,3.067,0.309c13.255,0,24-10.745,24-24S341.213,72,327.958,72z"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'wrist'})">
                <path :style="skin_color" d="M139.025,72.309C138.01,72.178,137.009,72,135.958,72c-13.255,0-24,10.745-24,24s10.745,24,24,24
                    c1.051,0,2.052-0.178,3.067-0.309C149.59,161.23,187.131,192,231.958,192c8.278,0,16.302-1.063,23.959-3.035
                    c0.053-0.016,0.124-0.063,0.176-0.076c-41.452-10.626-72.136-48.124-72.136-92.889c0-44.766,30.684-82.264,72.136-92.889
                    c-0.085-0.022-0.173-0.069-0.258-0.094C248.203,1.059,240.207,0,231.958,0C187.131,0,149.59,30.77,139.025,72.309z"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'eye'})">
                <path :style="eye_color" d="M191.958,112L191.958,112c-4.418,0-8-3.582-8-8v-8c0-4.418,3.582-8,8-8l0,0c4.418,0,8,3.582,8,8v8
                    C199.958,108.418,196.377,112,191.958,112z"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'eye'})">
                <path :style="eye_color" d="M271.958,112L271.958,112c-4.418,0-8-3.582-8-8v-8c0-4.418,3.582-8,8-8l0,0c4.418,0,8,3.582,8,8v8
                    C279.958,108.418,276.377,112,271.958,112z"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'mouth'})">
                <path :style="mouth_color" d="M243.958,128c-1.794,0-3.526,0.294-5.171,0.838c-4.388,1.452-9.27,1.452-13.658,0
                    c-1.645-0.544-3.377-0.838-5.171-0.838c-11.046,0-20,10.745-20,24s8.954,24,20,24c1.794,0,3.526-0.294,5.171-0.838
                    c4.388-1.452,9.27-1.452,13.658,0c1.645,0.544,3.377,0.838,5.171,0.838c11.046,0,20-10.745,20-24S255.004,128,243.958,128z"/>
            </g>
        </g>
        <g>
            <g @click="$emit('change', {event: $event, item: 'pacifier'})">
                <path :style="pacifier_color" d="M231.958,180c-12.789,0-23.945-8.641-27.125-21.016c-0.664-2.586-0.086-5.301,1.586-7.449
                    c1.719-2.215,4.406-3.535,7.195-3.535h36.688c2.789,0,5.477,1.32,7.195,3.535c1.672,2.148,2.25,4.863,1.586,7.445
                    C255.904,171.359,244.747,180,231.958,180z M213.615,156c-0.398,0-0.711,0.227-0.875,0.441
                    c2.117,9.387,10.086,15.559,19.219,15.559s17.102-6.172,19.375-15.008c-0.32-0.766-0.633-0.992-1.031-0.992H213.615z"/>
            </g>
        </g>
        <g>
            <g>
                <circle style="fill:#FFFFFF;" cx="231.958" cy="152" r="16"/>
            </g>
        </g>
        <g>
            <g>
                <path style="fill:#FFE5D1;" d="M223.958,152c0-7.447,5.111-13.65,12-15.434c-1.286-0.334-2.61-0.566-4-0.566
                    c-8.836,0-16,7.163-16,16c0,8.836,7.164,16,16,16c1.39,0,2.714-0.232,4-0.566C229.069,165.65,223.958,159.447,223.958,152z"/>
            </g>
        </g>
        <g v-if="gender === 'Boy'">
            <g @click="$emit('change', {event: $event, item: 'hair'})">
                <path :style="pacifier_color" d="M241.349,8.125c-4.336-0.813-8.508,2.133-9.266,6.484c-0.773,4.352,2.133,8.5,6.484,9.266
                    c2.969,0.531,3.922,2.375,4.188,3.148c0.258,0.727,0.516,2.156-0.648,3.477c-1.883,2.117-7.164,3.68-16.461,1.68
                    c-12.547-2.703-12.641-12.031-11.578-17.352c1.295-6.48,5.645-12.762,11.321-14.564c-8.774,0.595-17.208,2.379-25.172,5.178
                    c-0.78,2.039-1.414,4.129-1.837,6.254c-2.953,14.789,3.297,31.688,23.891,36.125c4.203,0.906,7.914,1.289,11.195,1.289
                    c11.516,0,17.703-4.703,20.633-8.023c4.719-5.344,6.125-12.578,3.758-19.344C255.365,14.594,249.185,9.508,241.349,8.125z"/>
            </g>
        </g>
        <g v-else>
            <g @click="$emit('change', {event: $event, item: 'body'})">
                <path :style="body_color" d="M270.638,0.111l-38.685,6.448l-38.685-6.448c-4.876-0.813-9.315,2.948-9.315,7.891v13.113    c0,4.943,4.439,8.704,9.315,7.891l38.685-6.447l38.685,6.447c4.876,0.813,9.315-2.948,9.315-7.891V8.002    C279.954,3.059,275.515-0.702,270.638,0.111z"/>
                <g>
                    <g>
                        <path :style="wrist_color" d="M255.954,18.558h-48c-2.211,0-4-1.789-4-4s1.789-4,4-4h48c2.211,0,4,1.789,4,4       S258.165,18.558,255.954,18.558z"/>
                    </g>
                </g>
            </g>
            <g>
                <g>
                    <g @click="$emit('change', {event: $event, item: 'arm'})">
                        <path :style="arm_color" d="M239.954,26.558h-16c-2.209,0-4-1.791-4-4v-16c0-2.209,1.791-4,4-4h16c2.209,0,4,1.791,4,4v16       C243.954,24.767,242.163,26.558,239.954,26.558z"/>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>

</template>

<script>
export default {
    props: {
        weight: {
            type: Number,
            default: 1
        },
        height: {
            type: Number,
            default: 1
        },
        gender: {
            type: String,
            default: 'Girl'
        },
        color: {
            type: Object,
            default: () => ({
                skin: '#FFD6B3',
                arm:  '#00AA9A',
                wrist: '#009D93',
                body: '#00BEA5',
                circle1: '#B2C56D',
                circle2: '#FFC855',
                mouth: '#00BEA5',
                pacifier: '#007D82',
                eye: '#6E4141',
                hair: '#C3A587'
            }),
        }
    },
    computed: {
        skin_color() {
            return `fill:${this.color.skin}`
        },
        body_color() {
            return `fill:${this.color.body}`
        },
        arm_color() {
            return `fill:${this.color.arm}`
        },
        wrist_color() {
            return `fill:${this.color.wrist}` 
        },
        circle_1_color() {
            return `fill:${this.color.circle1}` 
        },
        circle_2_color() {
            return `fill:${this.color.circle2}` 
        },
        mouth_color() {
            return `fill:${this.color.mouth}`  
        },
        pacifier_color() {
            return `fill:${this.color.pacifier}`
        },
        eye_color() {
            return `fill:${this.color.eye}`
        },
        hair_color() {
            return `fill:${this.color.hair}`
        },
        light_color() {
            return this.skin_color
        }
    }
}
</script>
